<template>
  <QS-scroller-box>
    <TopPreview
      :dataList="topPreviewModelList"
      :model="topPreviewModel"
    />
    <!-- 合同签署 -->
    <QS-h4-title title="合同签署" />

    <!-- 合同签署表单 -->
    <contractSigningForm
      ref="contractRef"
      :rentCategory="rentCategory"
      :orderId="topPreviewModel.orderId"
      :isRenewOrder="false"
    />

    <!-- 司管信息 -->
    <DriverManager
      :dm="manager"
      mode="edit"
      showSave
      :orderId="+topPreviewModel.orderId"
    />
    <template slot="bottomAction">
      <el-button
        @click="cancel"
        size="mini"
      >取消</el-button>
      <el-button @click="previousStep" size="mini">上一步</el-button>
      <el-button
        @click="confirmSubmit"
        :loading="loading"
        size="mini"
        type="primary"
      >确认，下一步</el-button>
    </template>
  </QS-scroller-box>
</template>
<script>
import {
  leaseContractOrderDetail,
  checkOrderBack,
} from '@/api/purchaseAndSaleAPI'
import { confirmContract } from '@/api/domain/orders'
import DriverManager from '@/components/DriverManager/index.vue'
import TopPreview from '../components/TopPreview.vue'
import contractSigningForm from '@/pages/orders/components/contractSigningForm/index.vue'
// eslint-disable-next-line import/no-cycle
import config from '../config'
import { cloneDeep } from 'lodash'

export default {
  components: {
    TopPreview,
    DriverManager,
    contractSigningForm,
  },
  props: {
    active: {
      type: Number,
      default: -1,
    },
    topPreviewModel: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      loading: false,
      manager: null,
      rentCategory: '',
    }
  },
  computed: {
    // 顶部预览数据
    topPreviewModelList() {
      const { c_topPreviewList } = config.call(this)
      return c_topPreviewList
    },
  },
  mounted() {
    this.init()
  },
  activated() {
    this.init()
  },
  methods: {
    // eslint-disable-next-line vue/no-unused-properties
    orderInfoJumpRender(type) {
      if (type === 'customer' && !this.topPreviewModel.customerName) {
        return ''
      } else if (type === 'car' && !this.topPreviewModel.plateNo) {
        return ''
      }
      const routeParams = {
        customer: {
          path: '/driver/customerManage/detail',
          query: {
            id: this.topPreviewModel.customerId,
            customerType: 1,
          },
          text: '查看客户信息',
        },
        car: {
          path: '/vehicle/vehicleManage/detail',
          query: {
            id: this.topPreviewModel.carId,
            plateNo: this.topPreviewModel.plateNo,
          },
          text: '查看车辆及保单信息',
        },
      }
      const data = {
        on: {
          click: () => this.$router.push(
            { path: routeParams[type].path, query: routeParams[type].query },
          ),
        },
      }
      return (
        <elButton type="text" {...data}>{routeParams[type].text}</elButton>
      )
    },

    // 获取详情
    getLeaseContractOrderDetail() {
      this.loading = true
      leaseContractOrderDetail({
        orderId: this.topPreviewModel.orderId,
      }).then((res) => {
        const { data } = res
        if (data) {
          const {
            deptName,
            customerName,
            customerId,
            planName,
            modelName,
            plateNo,
            carId,
            rentCategoryName,
            startDate,
            endDate,
            storeName,
            manager,
            rentCategory,
            brandName,
            seriesName,
          } = data
          this.manager = manager
          this.rentCategory = rentCategory

          /* eslint-disable vue/no-mutating-props */
          this.topPreviewModel.deptName = deptName
          this.topPreviewModel.customerName = customerName
          this.topPreviewModel.customerId = customerId
          this.topPreviewModel.planName = planName || '自定义'
          this.topPreviewModel.brandName = brandName
          this.topPreviewModel.seriesName = seriesName
          this.topPreviewModel.modelName = modelName
          this.topPreviewModel.rentCategoryName = rentCategoryName
          this.topPreviewModel.plateNo = plateNo
          this.topPreviewModel.carId = carId
          this.topPreviewModel.startStopDate = `${startDate}至${endDate}`
          this.topPreviewModel.storeName = storeName

          this.topPreviewModel = cloneDeep(this.topPreviewModel)
        }
        this.loading = false
      })
    },
    // 取消
    cancel() {
      this.$confirm(
        '是否确认退出创建个人签约提车流程?',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        },
      ).then(() => {
        this.$emit('cancel')
      }).catch(() => null)
    },
    // 上一步
    async previousStep() {
      const { code } = await checkOrderBack({
        orderId: this.$route.query.orderId,
      })
      if (code === 1) {
        this.$emit('previousStep', this.$route.query.orderId)
      }
    },
    // 下一步
    confirmSubmit() {
      const contractData = this.$refs.contractRef.validAndGetData()
      if (!contractData) return
      const { orderId } = this.topPreviewModel
      this.loading = true
      confirmContract({
        orderId,
        ...contractData,
      }).then((res) => {
        const { code } = res
        if (code === 1) {
          this.$router.replace({
            path: '/car_to_lease/forRentSignContract/personalSignContract',
            query: {
              stepsActive: this.active + 1,
              orderId,
            },
          })
        }
      }).catch((err) => {
        if (err.code === 22029) {
          this.$message.error(err.msg)
        }
      }).finally(() => {
        this.loading = false
      })
    },
    init() {
      // 获取订单详情
      this.getLeaseContractOrderDetail()
    },
  },
}
</script>
<style scoped>
::v-deep .bottom-action-inner{
  border-bottom-left-radius: 6px;
  border-bottom-right-radius: 6px;
  bottom: 10px;
}
</style>
